import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';

const FALLBACK_COLOR = '#9CA3AF';

/**
 * Job-status breakdown for the selected week.
 * @param {{data: Array<{name: string, value: number, color: string}>}} props - slices, largest first.
 */
const JobStatusDonut = ({ data }) => {
  const slices = (Array.isArray(data) ? data : []).filter((d) => Number(d?.value) > 0);
  const total = slices.reduce((sum, d) => sum + Number(d.value), 0);

  if (slices.length === 0) {
    return (
      <div className="text-center text-gray-500 py-12">
        <p>No jobs recorded for this week.</p>
      </div>
    );
  }

  const summary = slices.map((d) => `${d.name}: ${d.value}`).join(', ');

  return (
    <div className="relative" role="img" aria-label={`Job status breakdown, ${total} jobs total. ${summary}.`}>
      <ResponsiveContainer width="100%" height={280}>
        <PieChart accessibilityLayer>
          <Pie
            data={slices}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="45%"
            innerRadius={68}
            outerRadius={104}
            paddingAngle={2}
            stroke="none"
            isAnimationActive={false}
          >
            {slices.map((d) => <Cell key={d.name} fill={d.color || FALLBACK_COLOR} />)}
          </Pie>
          <Tooltip
            formatter={(v, n) => [`${v} job${Number(v) === 1 ? '' : 's'}`, n]}
            contentStyle={{ borderRadius: 8, border: '1px solid #E5E7EB', fontSize: 12 }}
          />
          <Legend layout="horizontal" verticalAlign="bottom" align="center" iconType="circle" wrapperStyle={{ fontSize: 12 }} />
        </PieChart>
      </ResponsiveContainer>
      {/* Centre total sits over the ring rather than using a recharts label render-prop */}
      <div className="pointer-events-none absolute inset-x-0 top-[38%] flex flex-col items-center" aria-hidden="true">
        <span className="text-3xl font-bold text-gray-800">{total}</span>
        <span className="text-xs text-gray-500">jobs</span>
      </div>
    </div>
  );
};

export default JobStatusDonut;
